module.exports = __webpack_public_path__ + "img/cbf426f507183972f6e74ceac72bfd66.png";